import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const InvestmentsLanding = lazy(() =>
  import("Components/Investments/InvestmentsLanding")
);
const UITFInner = lazy(() => import("Components/Investments/UITFInner"));

const BrokersandDealers = lazy(() =>
  import("Components/Investments/BrokersandDealers")
);
const InvestmentsInner = lazy(() =>
  import("Components/Investments/InvestmentsInner")
);
const UITFFeatures = lazy(() => import("Components/Investments/UITFFeatures"));
const UITFRiskDisclosure = lazy(() =>
  import("Components/Investments/UITFRiskDisclosure")
);
const Kiids = lazy(() => import("Components/Kiids"));
const ListiclePage = lazy(() => import("Components/ListiclePage"));

const InvestmentRoutes = () => {
  return (
    <Switch>
      <Route
        path="/investments/unitinvestmenttrustfunds/keyinformationandinvestmentdisclosurestatement"
        component={Kiids}
      />
      <Route
        path="/investments/unitinvestmenttrustfunds/features"
        component={UITFFeatures}
      />
      <Route
        path="/investments/sec-registered-brokers-and-dealers"
        component={BrokersandDealers}
      />
      <Route
        path="/investments/unitinvestmenttrustfunds/globalinvestmentperformancestandards"
        component={ListiclePage}
      />
      <Route
        path="/investments/unitinvestmenttrustfunds/declarationoftrust"
        component={ListiclePage}
      />
      <Route
        path="/investments/unitinvestmenttrustfunds/riskdisclosurestatement"
        component={UITFRiskDisclosure}
      />
      <Route
        path="/investments/unitinvestmenttrustfunds"
        component={UITFInner}
      />
      <Route path="/investments/:id" component={InvestmentsInner} />
      <Route path="/investments" component={InvestmentsLanding} />
    </Switch>
  );
};

export default InvestmentRoutes;
